import React from 'react'
import { Card, Space } from 'antd'
import UsersTable from './UsersTable'
import UserSearchInput from './UserSearchInput'
import { useSelector } from 'react-redux'
import { isNumber } from 'lodash'
import EditUserDrawer from '../edit/EditUserDrawer'
import InviteUserButton from '../invite/InviteUserButton'
import userSelectors from '../../../../../store/selectors/user.selectors'
import useAuthorization from '../../../../../components/authorization/useAuthorization'
import UserRoles, { UserTypes } from '../../../../../constants/UserRoles'

const UsersCard = () => {
    const editingUserId = useSelector(userSelectors.editingUserId)
    const { isAuthorized: isSystemAdmin } = useAuthorization([UserRoles.ADMIN], [UserTypes.SYSTEM_ADMIN])

    const extra = (
        <Space>
            <UserSearchInput />
            <InviteUserButton />
        </Space>
    )
    
    const title = isSystemAdmin ? 'Users' : 'Organization Users'

    return (
        <Card title={title} bordered={false} extra={extra}>
            <UsersTable />
            {isNumber(editingUserId) && <EditUserDrawer />}
        </Card>
    )
}

export default UsersCard
